import {isArray, isFunction} from "lodash";
import React from "react";

export const makeCustomTooltip = ({
    skipFn,
    formatValue,
    formatLabel,
    showUnit = true,
}) => {
    return ({label, payload}) => {
        return (
            <div className="compare-insertion-tooltip recharts-default-tooltip">
                <div>{formatLabel(label)}</div>
                <ul>
                    {!!payload &&
                        payload.map((item, i) => {
                            // nie chcemy wyświetlać labelka
                            if (isFunction(skipFn) && skipFn(item)) return null;
                            return (
                                <li key={i} style={{color: item.fill}}>
                                    <span>
                                        {item.name}
                                        {": "}
                                        {isArray(item.value) && (
                                            <>
                                                {item.value
                                                    .map((v) =>
                                                        isFunction(formatValue)
                                                            ? formatValue(v)
                                                            : v
                                                    )
                                                    .join("-")}
                                                {showUnit ? item.unit : ""}
                                            </>
                                        )}
                                        {!isArray(item.value) && (
                                            <>
                                                {isFunction(formatValue)
                                                    ? formatValue(item.value)
                                                    : item.value}
                                                {showUnit ? item.unit : ""}
                                            </>
                                        )}
                                    </span>
                                </li>
                            );
                        })}
                </ul>
            </div>
        );
    };
};
